export default {
    install(Vue, options) {
        Vue.mixin({
            data() {
                return {
                    CONST: options
                };
            }
        });
    }
};
